var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasMeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visuel/gas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visuel/gas",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#DDD3F1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 12,
    r: 12
  })), /*#__PURE__*/React.createElement("g", {
    id: "mdi:gas",
    transform: "translate(3, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2204792,10.9370145 C13.0493076,10.7159556 12.8409247,10.5243712 12.6474263,10.3327868 C12.1487958,9.8906689 11.5831851,9.57381775 11.1068813,9.10959397 C9.9979866,8.0337738 9.75239247,6.25793364 10.4594059,4.89473684 C9.75239247,5.06421536 9.13468603,5.44738419 8.60628654,5.86739618 C6.67874476,7.4000715 5.91963564,10.1043592 6.82758968,12.4254781 C6.85735867,12.4991644 6.88712765,12.5728507 6.88712765,12.6686429 C6.88712765,12.8307528 6.77549396,12.9781254 6.62664903,13.0370745 C6.45547737,13.1107608 6.27686346,13.066549 6.13546078,12.9486509 C6.09296901,12.9138668 6.05760108,12.8713449 6.03126933,12.8233842 C5.1902955,11.7696699 5.05633507,10.2591005 5.62194579,9.05064492 C4.37909066,10.0527788 3.70184625,11.747564 3.79859545,13.346557 C3.84324893,13.7149886 3.8879024,14.0834201 4.01442059,14.4518517 C4.11861204,14.8939696 4.31955269,15.3360875 4.54282008,15.7266249 C5.34658267,17.0013981 6.73828273,17.9151084 8.23417423,18.0993242 C9.82681493,18.2982773 11.5310893,18.0109006 12.7516177,16.9203432 C14.1135488,15.6971504 14.5898525,13.7370945 13.8902814,12.0570465 L13.7935322,11.8654621 C13.637245,11.5265051 13.2204792,10.9370145 13.2204792,10.9370145 M11.1114694,16.2143868 C10.7708188,16.5105154 10.2111786,16.8313215 9.77319921,16.9547084 C8.4105968,17.4482562 7.04799439,16.7572893 6.24503225,15.9429355 C7.69279731,15.597452 8.55658991,14.5116469 8.81207787,13.4135031 C9.01890145,12.4264075 8.62958647,11.6120537 8.47142726,10.6619742 C8.32543415,9.74891078 8.34976633,8.97157302 8.67825084,8.12020309 C8.90940661,8.58907349 9.15272847,9.05794388 9.4447147,9.42810472 C10.3815039,10.6619742 11.8536011,11.2048767 12.1699195,12.8829392 C12.2185839,13.0556809 12.2429161,13.2284227 12.2429161,13.4135031 C12.2794144,14.425276 11.841435,15.5357586 11.1114694,16.2143868 Z",
    id: "Shape",
    fill: "#5A2C71",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasMeter);
export default __webpack_public_path__ + "static/media/gas-meter.b0a9549ba08da85fda4f831e7d34a5a5.svg";
export { ForwardRef as ReactComponent };